package com.evoapps.evoshift.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class InviteDetails(
    val workplaceName: String,
    val inviterName: String
)
